
/**
 * 토픽 기본 정보
 */
export type ExploreContentItemContentOneOfThreesevenBasicInfoAllOfTwo = {
  title: string;
};
